import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const domainSuggestionsAi = async _ref => {
  let {
    httpClient,
    request: {
      domain,
      aiChatMessages,
      domainsCount
    }
  } = _ref;
  const parsedDomain = domain != null && domain.main ? domain : parseDomain(domain);
  const validDomainName = parsedDomain.fullAsciiDomain;
  let domainNamesToSuggest = [];
  const {
    domainsGptSuggestions,
    suggestDomains
  } = await dynamicLoadApiQueries(httpClient);
  const {
    domainNames
  } = await domainsGptSuggestions({
    similarTo: [parsedDomain.formattedInput],
    domainsCount,
    fallbacksCount: 3,
    secureAvailability: true,
    descriptions: [`
        Please use the following messages to generate domain suggestions:
        ${aiChatMessages.map(message => `- ${message.role}: ${message.content}`).join('\n')}
        ** If domain name is included in the request please take it into account. when generating suggestions.
        ** Don't include the domain name in the suggestions.
        `]
  });
  domainNamesToSuggest = [...domainNames];
  if (domainNames.length < domainsCount) {
    var _ref2;
    const {
      suggestions
    } = await suggestDomains({
      query: validDomainName,
      paging: {
        limit: domainsCount + 2 - domainNames.length
      }
    });
    domainNamesToSuggest = [...domainNamesToSuggest, ...((_ref2 = suggestions ?? []) == null ? void 0 : _ref2.map(suggestion => suggestion.domain))];
  }
  return {
    suggestions: domainNamesToSuggest
  };
};
//# sourceMappingURL=domainSuggestionsAi.js.map